module.exports = __webpack_public_path__ + "files/e030d6c8927ccae30e1ce728cc998ac7.svg";